import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';

import './ScrollTo.scss';

const ScrollTo = ({
  behavior, children, offset, when,
}) => {
  const anchorRef = useRef(null);

  useEffect(() => {
    if (when && anchorRef.current) {
      anchorRef.current.scrollIntoView({ behavior });
    }
  }, [when, behavior]);

  return (
    <div className="ScrollTo">
      <div className="ScrollTo__anchor" ref={anchorRef} style={{ top: offset }} />
      {children}
    </div>
  );
};

ScrollTo.propTypes = {
  behavior: PropTypes.string,
  children: PropTypes.node.isRequired,
  offset: PropTypes.number,
  when: PropTypes.bool.isRequired,
};

ScrollTo.defaultProps = {
  behavior: 'auto',
  offset: 0,
};

export default ScrollTo;
